module.exports = __webpack_public_path__ + "files/8a60a516be5d1b552d59243462c872ad.png";